export default {
    common: {
        noData: '아직 데이터가 없습니다',
        copy: '복사',
        copySuccess: '복사 성공! ',
        confirmText: '확인하다',
        cancelText: '취소',
        sendSuccess: '성공적으로 보냈습니다! ',
        qrCodeDownloadApp: '코드를 스캔하여 App을 다운로드하다.'
    },
    login: {
        title: '로그인',
        enterUserName: '이메일/사용자 이름을 입력하세요',
        enterPassword: '비밀번호를 입력해주세요',
        enterLogin: '로그인',
        forgotPassword: '비밀번호를 잊어버렸어요',
        register: '계정 등록',
    },
    register: {
        title: '등록하다',
        enterUserName: '사용자 이름',
        enterPassword: '비밀번호',
        enterEmail: '이메일',
        enterCode: '이메일 인증번호',
        inviteCode: '초대코드(선택)',
        sendEmailCode: '인증코드 전송',
        enterUserNameErr: '사용자 이름을 입력하세요',
        enterUserNameErr2: '사용자 이름은 6~16자의 문자 또는 숫자로 구성됩니다',
        enterPasswordErr: '비밀번호를 입력해주세요',
        enterPasswordErr2: '비밀번호는 영문 8~18자리, 숫자, 특수기호로 구성됩니다',
        enterEmailErr: '이메일 주소를 입력해주세요',
        enterEmailErr2: '올바른 이메일 주소를 입력해주세요',
        enterCodeErr: '이메일 인증번호를 입력해주세요',
        enterRegister: '등록하다',
        registerSuccess: '등록이 완료되었습니다. 로그인 페이지로 리디렉션됩니다...',
        toLogin: '이미 계정이 있나요? 직접 로그인',
        emailCodeTip: '받은 편지함에 이메일이 도착하지 않은 경우 스팸으로 잘못 식별되었을 수 있습니다. 이메일 스팸 폴더를 확인하세요. '
    },
    forgotPassword: {
        title: '비밀번호를 잊어버렸어요',
        enterEmail: '이메일',
        enterCode: '이메일 인증번호',
        sendEmailCode: '인증코드 전송',
        enterEmailErr: '이메일 주소를 입력해주세요',
        enterEmailErr2: '올바른 이메일 주소를 입력해주세요',
        enterCodeErr: '이메일 인증번호를 입력해주세요',
        enterPassword: '새 비밀번호',
        enterPasswordErr: '새 비밀번호를 입력해주세요',
        enterPasswordErr2: '비밀번호는 영문 8~18자리, 숫자, 특수기호로 구성됩니다',
        enterBtn1: '취소',
        enterBtn2: '확인하다',
        forgotPasswordSuccess: '수정이 완료되었습니다. 로그인 페이지로 리디렉션됩니다...'
    },
    layoutHeader: {
        login: '로그인',
        register: '등록하다',
        nav: ['호가', '플랫폼', '퍼블릭 체인', '비문', '청산', '스마트 머니', '롱 앤 숏', '큰손', '비율', '뉴스', '애플리케이션'],
        navHyperliquid: 'Hyperliquid 고래 모니터링',
        userNav1: '로그인',
        userNav12: '지갑 명세',
        userNav2: '코인 출금',
        userNav13: '동전 인출 기록',
        userNav3: '계약서 확인',
        userNav4: '초대링크',
        userNav5: '모으다',
        userNav6: '길',
        userNav7: '팀',
        userNav8: '도구',
        userNav9: '그만두다',
        userNav10: 'API 바인딩',
        userNav11: '새로운 로봇을 만들다',
        searchPlaceholder: '주소 또는 통화 쿼리',
        historyTitle: '이력 검색 이력',
        searchTitle1: '계약',
        searchTitle2: '통화',
        searchList1_1: '이름',
        searchList1_2: '온체인 거래량',
        searchList1_3: '가격',
        searchList2_1: '이름',
        searchList2_2: '유통량',
        searchList2_3: '가격',
        searchNoResult: '아직 검색결과가 없습니다',
    },
    layoutTop: {
        topTitle1: '주류 통화 시장 참조',
        topTitle2: '감정 지표',
        sentimentIndexBlock1: '감정지수',
        sentimentIndexBlock1_1: '극심한 패닉',
        sentimentIndexBlock1_2: '공황',
        sentimentIndexBlock1_3: '중립적',
        sentimentIndexBlock1_4: '탐욕스러운',
        sentimentIndexBlock1_5: '과도한 탐욕',
        sentimentIndexBlock2: 'BTC 포지션 롱 및 숏',
        sentimentIndexBlock2_1: '황소 이점',
        sentimentIndexBlock2_2: '짧은 장점',
        trend24h: '24시간 추이',
        past24h: '지난 24시간',
        candleSummary: 'BTC 종가: 최근 30분봉 48개',
        chartLoading: '차트 불러오는 중…',
        chartUnavailable: '차트 데이터를 일시적으로 불러올 수 없습니다',
        sentimentDetails: '상세 보기',
        sentimentUnavailable: '데이터 없음',
        btcRatio: 'BTC 롱/숏',
        ratioShare: '롱 {long}% · 숏 {short}%',
        moodHistory: '과거 지수',
        moodRecentDays: '최근 {count}일',
        moodVsYesterday: '전일 대비 {value}',
        moodUnchanged: '전일과 동일',
    },
    layoutSection: {
        title1: '스마트머니',
        title2: '보조 도구',
        titleMore: '더보기>>',
    },
    layoutFooter: {
        appTitle: '다운로드할 앱이 너무 많습니다',
        appNav1: '애플리케이션',
        appNav2: '지갑',
        appNav3: '사회적 접촉',
        explain1: '부인 성명:',
        explain2: '이 웹사이트의 모든 콘텐츠는 제3자 플랫폼에서 나온 것입니다. 우리는 웹사이트와 그 콘텐츠에 대해 어떠한 유형의 보증도 하지 않습니다. 웹사이트의 모든 블록체인 관련 데이터와 자료는 사용자 학습 및 연구 목적으로만 사용됩니다. 다른 분야에 대한 투자나 법적 제안 및 근거를 구성하지 않습니다. 귀하는 관련 데이터와 콘텐츠를 주의해서 사용해야 하며, 발생하는 모든 위험을 감수해야 합니다. 귀하는 콘텐츠에 대해 직접 조사, 검토, 분석 및 검증을 수행할 것을 적극 권장합니다. ',
        copyright: '2026 - 최종 해석권은 TokenTrend에 있습니다'
    },
    coinDetails: {
        titleLabel1: '24시간 가격 인상 또는 인하',
        titleLabel2: '24시간 최고가',
        titleLabel3: '24시간 최저가',
        titleLabel4: '거래량',
        titleLabel5: '보고량',
        titleLabel6: '역사상 최고가',
        titleLabel7: '역대 최저가',
        infoItem1: '통화:',
        infoItem2: '공식 웹사이트 링크:',
        infoItem3: '24시간 최고가:',
        infoItem4: '24시간 최저가:',
        infoItem5: '순환량:',
        infoItem6: '총 발행량:',
        infoItem7: '최대 순환량:',
        infoItem8: '시장 출시 시간:',
        infoItem9: '가격 시작 시간:',
        infoItem10: '백서 링크:',
    },
    newCoinDetails: {
        titleLabel0: '직접 링크:',
        titleLabel1: '순환',
        titleLabel2: '유통율',
        titleLabel3: '판매 수량',
        titleLabel4: '총 발행량',
        titleLabel5: '24시간 증가',
        titleLabel6: '최신 가격',
        titleLabel7: '제안 가격',
        titleLabel8: '예매시간',
        titleLabel9: '코인 상장 플랫폼',
        titleLabel10: '매출비중',
        listTitle: '시장 상황',
        list1: '거래 플랫폼',
        list2: '동전쌍',
        list3: '24시간 거래량',
        list4: '24시간 거래량($)',
        list5: '비율',
    },
    platformDetails: {
        title: '플랫폼 세부정보',
        website: '공식 웹사이트:',
        volumn24h: '24시간 거래량:',
        riseFall24h: '24시간 증가 또는 감소:',
        synopsis: '소개',
        content1: '설립시간',
        content2: '등록 장소',
        content3: 'KYC 인증',
        content4: '양자화 인터페이스',
        content5: '자산',
        content6: '거래 쌍의 수량',
        isTrue: '예',
        isFalse: '아니요',
        lastLinkTitle1: '거래 지원',
        lastLinkTitle2: '관련 링크',
        content8: '현물 거래',
        content9: '계약거래',
        content10: 'OTC',
        content11: '명목화폐 거래',
        title3: '관련 링크',
        content12: '페이스북',
        content13: '지저귀다',
        content14: '레딧',
        content15: '전보',
    },
    firmOffer: {
        titleLabel0: '계약 주소:',
        titleLabel1: '보유 주소 수',
        titleLabel2: '독립 거래 주소 수',
        titleLabel3: '거래 횟수',
        titleLabel4: '거래 금액',
        titleLabel5: '유동성',
        titleLabel6: '시가 총액',
        titleLabel7: '생성 시간',
        titleLabel8: '총 잠금 시가 총액',
        tabs1: '거래 내역',
        tabs2: '풀 변화',
        tabs3: '보유 주소',
        tabs4: '내 포지션',
        transactionTh1: '시간',
        transactionTh2: '유형',
        transactionTh3: '수량',
        transactionTh4: '가격',
        transactionTh5: '총 가치',
        transactionTh6: '사용자 주소',
        transactionTh7: '거래 해시',
        tag1: '구매',
        tag2: '판매',
        tag3: '추가',
        tag4: '감소',
        poolTip: '기본적으로 첫 번째 풀 데이터가 표시됩니다',
        poolTh1: '시간',
        poolTh2: '유형',
        poolTh3: '수량/토큰',
        poolTh4: '총 가치',
        poolTh5: '사용자 주소',
        poolTh6: '거래 해시',
        poolCurrent: '보유 주소 총 수',
        Explain1: '보유 주소 총 수:',
        Explain2: '상위 10 비율:',
        Explain3: '저격수 수:',
        Explain4: '의심스러운 보유 주소 수:',
        positionTh1: '순위',
        positionTh2: '주소',
        positionTh3: '보유 비율',
        positionTh4: '수량',
        positionTh5: '24시간 변화',
        positionTh6: '블록 정보',
        financeType1: '상위 구매자',
        financeType2: '상위 판매자',
        financeTh1buy: '순매수',
        financeTh1sell: '순매도',
        financeTh2buy: '구매 금액($)',
        financeTh2sell: '판매 금액($)',
        financeTh3: '사용자',
        addTrace: '현재 주소를 추적하시겠습니까?',
        addTraceSuccess: '추가 성공!',
    },
    market: {
        tabs1: '인기',
        tabs2: '상승률',
        tabs3: '하락률',
        tabs4: '신규 코인',
        tabs5: '급등',
        tabs6: '시가총액',
        tabs7: '거래금액',
        popularListTh0: '번호',
        popularListTh1: '코인',
        popularListTh2: '최신 가격',
        popularListTh3: '24H 상승률',
        popularListTh4: '24H 거래량',
        popularListTh5: '24H 거래금액',
        popularListTh6: '유통 시가총액',
        popularListTh7: '상장 시간',
    },
    platform: {
        tab1: '글로벌 거래소 자산 랭킹',
        ERGlobalRankingListTh1: '일련번호',
        ERGlobalRankingListTh2: '플랫폼',
        ERGlobalRankingListTh3: '자산($)',
        ERGlobalRankingListTh4: '24시간 거래량($)',
        ERGlobalRankingListTh5: '24시간 부침',
        ERGlobalRankingListTh6: '공식 홈페이지',
    },
    publicChain: {
        tableTh1: '페어',
        tableTh2: '가격/거래량', 
        tableTh3: '가격 변화/시가 총액',
        tableTh4: '거래 횟수',
        tableTh5: '거래 주소/토큰 보유 수',
        tableTh6: '유동성/시간'
    },
    inscription: {
        typeAll: '모두',
        tableTh1: '토큰 이름',
        tableTh2: '보유자',
        tableTh3: '총 거래 수',
    },
    burst: {
        title6: '지도 청산',
        currentPrice: '현재 가격：',
        liquidationTip1: '누적 다건 청산 강도',
        liquidationTip2: '누적 청구서 청산 강도',
        liquidationTip3: '10x 레버',
        liquidationTip4: '25x 레버',
        liquidationTip5: '50x 레버',
        liquidationTip6: '100x 레버',
        title1: '청산 히트맵',
        heatmapTop: 'Binance, Huobi, OKX의 3대 거래소 종합 데이터에 따르면, {0}USDT의 최대 청산 시점은 {1}에 가깝고, 청산 가치는 {2}USDT입니다. 자본 리스크에 주의하시기 바랍니다.',
        heatmapDetailsBtn: '세부',
        heatmapKLine1: 'k선',
        heatmapKLine2: '청산 강도',
        heatmapTip1: '가격',
        heatmapTip2: '청산 강도',
        kLineTip1: '시가',
        kLineTip2: '종가',
        kLineTip3: '최고가',
        kLineTip4: '최저가',
        noLogin: '오른쪽 상단을 클릭하시면 로그인이 되며, 로그인 후 히트맵을 보실 수 있습니다',
        title2: '청산 데이터',
        topBlockH41: '4H 청산',
        topBlockH42: '12H 청산',
        topBlockH43: '24시간 청산',
        topBlockP1: '청산한도',
        topBlockP2: '장거리 주문 비율',
        title3: '24H 청산순위',
        rankingTh1: '교환',
        rankingTh2: '통화',
        rankingTh3: '청산USD',
        rankingTh4: 'USD 매수',
        rankingTh5: '빈 주문 USD',
        title4: '화폐별 청산통계',
        title5: '네트워크 전체의 모든 거래소에서 청산된 포지션의 비율',
        burstStatisticsHistoryTitle: '환산이력통계정보',
        burstStatisticsHistoryTh1: '통화',
        burstStatisticsHistoryTh2: '장기주문 청산',
        burstStatisticsHistoryTh3: '단기 주문 청산',
        burstStatisticsHistoryTh4: '시간',
        heatmapDetailsTitle: '청산 히트맵 데이터',
        heatmapDetailsList1Top: '널',
        heatmapDetailsList1Bottom: '많은',
        heatmapDetailsList1: '방향',
        heatmapDetailsList2: '가격',
        heatmapDetailsList3: '변제',
    },
    smartMoney: {
        typeTitle1: '상위 100개 고주파 거래',
        typMsg1: '8대 퍼블릭체인 상위 100개 종합소득/수익률',
        typeTitle2: '연예인 스마트머니',
        typMsg2: '글로벌 유명인/퍼블릭 체인 창업자/유명 기관 주소 추적',
        typeTitle3: '레벨1 스마트머니',
        typMsg3: '더 높고 안정적인 발행시장 수익률을 갖춘 스마트머니',
        typeTitle4: '맞춤형 스마트머니',
        typMsg4: '사용자가 추가한 지갑 주소 추적',
    },
    smartMoneyTop100: {
        topTip: '지난 30일 동안의 주요 DEX 종합 분석 데이터입니다. 잔액은 참고용입니다! ',
        sort: '일련번호',
        address: '주소',
        amountUsd: '균형',
        floatProfit: '떠 있는',
        floatProfitPercent: '유동이익률',
        profit: '이익',
        profitPercent: '수익률',
        collectTo: '모으다',
        collectCancel: '즐겨찾기 취소',
        noLogin: '로그인 후 세계에서 수익률이 가장 높은 스마트머니 100위를 확인하고 추적할 수 있습니다.',
        toLogin: '로그인으로 이동',
    },
    smartMoneyStar: {
        th1: '이름:',
        th2: '주소:',
        th3: '시간:',
    },
    smartMoneyOneLevel: {
        th1: '주소:',
        th2: '시간:',
    },
    smartMoneyCustom: {
        sort: '일련번호',
        name: '이름',
        address: '주소',
        time: '시간',
        addNameRules: '이름을 입력해주세요',
        addAddressRules: '주소를 입력해주세요',
        addConfirm: '확인하다',
        addSuccess: '성공적으로 추가되었습니다! ',
        addBtn: '맞춤 추가',
        delBtn: '삭제',
        delSuccess: '삭제 성공! ',
    },
    smartMoneyDetails: {
        type1: 'DEX 트레이딩',
        queryTokenAll: '모두',
        dexAddress: '주소:',
        dexHash: '거래 해시:',
        dexChainName: '체인 이름:',
        dexTransactionAmount: '거래 금액:',
        dexTrackerIn: '계약으로 전환:',
        dexTrackerOut: '계약 이전:',
        dexTrackerType: '거래 방향:',
        dexTrackerTypeCon: '{0}{1}은(는) {2}{3}로 변환됩니다.',
        dexTransactionTime: '거래 시간:',
        type2: '일반 환승',
        ordinaryHash: '거래 해시:',
        ordinaryTime: '시간:',
        ordinaryFrom: '보낸 사람 주소:',
        ordinaryTo: '수신자 주소:',
        ordinarySymbol: '통화 이름:',
        ordinaryAmount: '이체 수량:',
    },
    manyEmpty: {
        title1: '글로벌 계좌 장단기 비율',
        title2: '상위계정 장단기 비율',
        title3: '상위계좌 보유 장단기 비율',
        progress1: '긴:',
        progress2: '짧은:',
        tableTh1: '교환',
        tableTh2: '롱-숏 비율',
        tableTh3: '매수 포지션 비율',
        tableTh4: '짧은 공유',
    },
    whale: {
        holdingsTitle: '회색조 위치 목록',
        holdingsTitle2: '업데이트 시간:',
        holdingsTh1: '포지션 변경',
        holdingsTh1_1: '1일',
        holdingsTh1_2: '7일',
        holdingsTh1_3: '30일',
        holdingsTh2: '프리미엄 요금',
        holdingsTh3: '통화보유량',
        holdingsTh4: '위치 값',
        contractTitle: '총 계약 포지션',
        contractTh1: '교환',
        contractTh2: '위치값($)',
        contractTh3: '위치 수량',
        contractTh4: '15분 변화',
        contractTh5: '1일 변경',
        exchangeTitle: '환전잔액목록',
        exchangeTh1: '교환',
        exchangeTh2: '지갑 개수',
        exchangeTh3: '24시간 변경',
        exchangeTh4: '변화의 7일',
        exchangeTh5: '변화의 30일',
        statistics1: '총 시가총액:',
        statistics2: '24시간 거래량:',
        statistics3: '24시간 내 최고가:',
        listRight1: '시간',
        listRight2: '이체 주소',
        listRight3: '이체 주소',
        listRight4: '이체금액',
    },
    rate: {
        newTitle: '거래소 현재 펀딩 비율 목록',
        newTableTh1: '통화',
        newTableTd1: '예상 비율',
        oldTableTh1: '교환',
        oldTableTh2: '현재 환율',
        oldTableTh3: '최대 속도',
        oldTableTh4: '최저금리',
        oldTableTh5: '업데이트 시간',
    },
    consult: {
        nav1: '소식',
        nav2: '발표',
        nav3: '소식',
        detailsTime: '시간',
        detailsBack: '뒤로',
        details: '상세',
    },
    application: {
        nav1: '애플리케이션',
        nav2: '지갑',
        nav3: '사회적 접촉',
        visit: '바로가기',
        empty: '아직 없습니다',
        download: '다운로드',
        register: '등록하다'
    },
    userSignIn: {
        alreadySignIn: '{0}일 동안 체크인했습니다',
        signInBtn: '지금 로그인하세요',
        tip1: "{0}분 동안 플랫폼을 탐색하면 로그인 보상을 받을 수 있습니다.",
        tip2: '({0}분 {1}초를 보셨습니다)',
        success: '로그인이 완료되었습니다! ',
        recordTitle: '로그인 기록',
        recordListContent: '시간:',
    },
    userSignInRecord: {
        title: '지갑 세부정보',
        selectAll: '모두',
        typeSelect1: '로그인 보상',
        typeSelect2: '직접 승격 보상',
        typeSelect3: '팀 보상',
        typeSelect4: '현금인출 공제 신청',
        typeSelect5: '시스템이 증가를 거부합니다',
        th1: '유형',
        th2: '수량',
        th3: '시간',
    },
    userWithdrawal: {
        titleTip: '출금 주소는 TRON(TRC-20) 체인의 지갑 주소여야 합니다. 다른 체인의 지갑 주소를 입력하면 영구적인 손실이 발생하고 복구할 수 없습니다. ',
        withdrawalAddress: '출금 주소:',
        inputWithdrawalAddress: '출금주소를 입력해주세요',
        number: '수량',
        inputNumber: '수량을 입력해주세요',
        inputNumberErr: '균형이 부족하다',
        balance: '균형',
        actualReceipt: '실제 도착:',
        gas: '수수료:',
        tip: '최소 출금 금액은 {0}USDT이고, 출금 수수료는 {1}%입니다. ',
        confirm: '확신하는',
        explain: '온라인 거래에는 0~2시간이 소요되며 네트워크 확인은 포함되지 않습니다',
        submitSuccess: '제출 성공'
    },
    userWithdrawalRecord: {
        title: '출금 기록',
        list1: '주소',
        list2: '네트워크',
        list3: '통화',
        list4: '수량',
        list5: '취급 수수료',
        list6: '상태',
        list7: '시간',
        status0: '검토 대기 중',
        status1: '통과하다',
        status2: '거절하다',
    },
    userContractCheck: {
        enterPlaceholder: '계약주소를 입력해주세요',
        enterBtn: '조사하다',
        riskAssessment: '위험 평가',
        riskInspection: '리스크 체크',
        checkNFT1: ['비악성 NFT', '악성 NFT'],
        checkNFT2: ['오픈소스 아님', '오픈소스'],
        checkNFT3: ['대리점 없는 계약', '대리점과의 계약'],
        checkNFT4: ['확인되지 않음', '확인됨'],
        checkNFT5: ['유명하고 믿을 수 있는 NFT가 아니다', '유명하고 믿을 수 있는 NFT'],
        checkToken1: ['최대 거래금액 또는 최대 토큰 포지션을 수정하는 기능이 없습니다', '최대 거래금액 또는 최대 토큰 포지션을 수정하는 기능이 있습니다'],
        checkToken2: ['소유권을 회복할 수 없습니다', '소유권을 회복할 수 있습니다'],
        checkToken3: ['계약에는 숨은 주인이 없습니다', '계약에는 숨은 주인이 있습니다'],
        checkToken4: ['단일 주소의 최대 거래량 또는 최대 포지션을 제한하는 기능이 없습니다', '단일 주소의 최대 거래량 또는 최대 포지션을 제한하는 기능이 있습니다'],
        checkToken5: ['토큰은 허니팟이 아니다', '토큰은 허니팟이다'],
        checkToken6: ['토큰은 탈중앙화 거래소에서 거래될 수 없습니다.', '토큰은 탈중앙화 거래소에서 거래될 수 있습니다.'],
        checkToken7: ['계약에는 토큰을 발행할 수 있는 능력이 없습니다.', '계약에는 토큰을 발행할 수 있는 능력이 있습니다.'],
        checkToken8: ['오픈소스 아님', '오픈소스'],
        checkToken9: ['대리인이 아닙니다', '대리인입니다'],
        checkToken10: ['계약 소유자는 토큰 보유자 잔액을 변경할 수 없습니다', '계약 소유자는 토큰 보유자 잔액을 변경할 수 있습니다'],
        checkToken11: ['할당된 주소마다 다른 세율을 설정할 수 없습니다.', '할당된 주소마다 다른 세율을 설정할 수 있습니다.'],
        checkToken12: ['계약은 자멸할 수 없다', '계약은 자멸할 수 있다'],
        checkToken13: ['계약에 거래 냉각 메커니즘이 없습니다', '계약에 거래 냉각 메커니즘이 있습니다'],
        checkToken14: ['토큰 계약을 통해 거래를 중단할 수 없습니다.', '토큰 계약을 통해 거래를 중단할 수 있습니다.'],
        checkToken15: ['이 토큰은 유명하고 신뢰할 수 있는 토큰이 아닙니다', '이 토큰은 유명하고 신뢰할 수 있는 토큰입니다'],
        botToken1: '소유자 주소',
        botToken2: '오너 잔액',
        botToken3: '소유자가 보유한 토큰의 비율',
        botToken4: '공급량',
        botNFT1: '총 거래량',
        botNFT2: '보유자 수',
        botNFT3: '최고가',
        botNFT4: '24시간 평균 가격',
        botNFT5: '24시간 최저가',
    },
    userCollect: {
        title: '모으다',
        sort: '일련번호',
        address: '주소',
        amountUsd: '균형',
        floatProfit: '떠 있는',
        floatProfitPercent: '유동이익률',
        profit: '이익',
        profitPercent: '수익률',
        cancel: '즐겨찾기 취소',
        cancelSuccess: '취소 성공! ',
    },
    userTrace: {
        title: '길',
        th1: '일련번호',
        th2: '공개 체인 이름',
        th3: '토큰 이름',
        th4: '주소',
        del: '삭제',
        delSuccess: '삭제 성공! ',
    },
    userTeam: {
        title: '팀',
        topInfo1: '인원수를 직접 추천하다',
        topInfo2: '팀 수',
        topInfoUnit: '사람',
        th1: '사용자 이름:',
        th2: '등록 시간:',
    },
    userTool: {
        tool1: 'BTC 회사 입장',
        tool2: '감정지수',
        tool3: '멘토구 모니터링',
        tool4: 'OTC 가격',
        tool5: '외부 디스크 데이터',
        tool6: '대형 트레이더들이 포지션을 늘린다',
        tool7: '대형 트레이더들 포지션 축소',
        tool8: '스테이블코인',
        tool9: '블록체인 브라우저',
    },
    userToolCompanyHoldings: {
        title: '글로벌 기업 BTC 보유 데이터',
        globalDataT1: 'BTC 지주회사',
        globalDataD1: '집',
        globalDataT2: '회사 전체 직위',
        globalDataD2: '지난 7일 동안의 변경사항:',
        globalDataT3: '포지션의 총 가치',
        globalDataD3: '지난 7일 동안의 변경사항:',
        globalDataT4: '포지션은 총 BTC 시장 가치를 설명합니다',
        globalDataD4: '7일 전 비율:',
        th1: '회사 이름',
        th2: '위치값($)',
        th3: 'BTC 시장 가치 계정',
        th4: 'BTC 포지션',
        th5: '지난 7일 동안의 순위 변동',
        th6: '총 보유 비용',
        th7: '평균비용($)',
    },
    userToolSentimentIndex: {
        title1: '공황과 탐욕 지수',
        title1_1: 'BTC 및 주요 주류 통화의 패닉 및 탐욕 지수',
        gauge1: '극심한 패닉',
        gauge2: '공황',
        gauge3: '중립적',
        gauge4: '탐욕스러운',
        gauge5: '과도한 탐욕',
        title2: '역사적 색인',
    },
    userToolMTGoxMonitor: {
        time: '업데이트 시간:',
        title1: '멘투구(MTGox) BTC 콜드월렛',
        topLabel1: '원래 보유했던 BTC 총액',
        topLabel1Span: '원래 값',
        topLabel2: '총 남은 BTC',
        topLabel2Span: '현재 가치',
        topLabel3: 'BTC 보유 방식 변경',
        title2: 'BTC 콜드월렛 체인의 전송 기록',
        th1: '거래시간',
        th2: '콜드 지갑 주소',
        th3: 'BTC 금액 전송',
    },
    userToolOutsidePrice: {
        th1: '토큰 이름',
        th2: '교환',
        th3: '평균 거래 가격',
        th4: '프리미엄',
    },
    userToolOutsideDisk: {
        itemTitleSpan: '고쳐 쓰다',
        itemTitle2: '영업 시간:',
        itemInfo1: '어제의 수확',
        itemInfo2: '오늘',
        itemInfo3: '오늘의 거래량',
        itemInfo4: '오늘 최고',
        itemInfo5: '오늘 최저',
        itemInfo6: '지난해 최고치',
        itemInfo7: '지난해 최저',
    },
    userToolLargeIncrease: {
        title: '대형 트레이더들이 포지션을 늘린다',
        titleMsg: '다른 기간의 여러 통화 또는 단일 통화의 경우 선택한 기간의 통화 상승 및 하락을 자동으로 계산합니다.',
        th1: '통화',
        th2: '24시간 부침',
        th3: '24H 위치 비율',
        th4: '주간 포지션 비율',
        th5: '월보유비율',
        th6: '글로벌 지수($)',
        th7: '상위 10위권 비율',
        th8: '상위 20위권 비율',
        th9: '상위 50위권 비율',
        th10: '상위 100위권 비율',
    },
    userToolLargeDecrease: {
        title: '대형 트레이더들 포지션 축소',
        titleMsg: '다른 기간의 여러 통화 또는 단일 통화의 경우 선택한 기간의 통화 상승 및 하락을 자동으로 계산합니다.',
        th1: '통화',
        th2: '24시간 부침',
        th3: '24H 위치 비율',
        th4: '주간 포지션 비율',
        th5: '월보유비율',
        th6: '글로벌 지수($)',
        th7: '상위 10위권 비율',
        th8: '상위 20위권 비율',
        th9: '상위 50위권 비율',
        th10: '상위 100위권 비율',
    },
    userToolStableCoin: {
        tab1: 'USDT 시세',
        UsdTopInfo1: 'USDT OTC 평균 가격',
        UsdTopInfo2: '달러 환율',
        UsdTopInfo3: 'USDT 프리미엄 요율',
        UsdTitleSub1: 'USDT 관련 지수 동향',
        UsdTitleSub2: 'USDT 프리미엄 관련 동향',
        UsdQuery1: '7일',
        UsdQuery2: '30일',
        tab2: '관련 스테이블코인',
        relatedTitleSub1: '스테이블코인 개요',
        relatedTopTh1: '통화',
        relatedTopTh2: '오프사이트 평균 가격($)',
        relatedTopTh3: '프리미엄 요금',
        relatedTopTh4: '현재 순환',
        relatedTopTh5: '유통시장가치($)',
        relatedQuery1: '30일',
        relatedQuery2: '거의 1년',
        relatedTitleSub2: '스테이블코인 유통',
        relatedTitleSub3: '스테이블코인 유통비율',
        relatedTitleSub4: '스테이블코인 체인 문제',
        relatedBottomTh1: '시간',
        relatedBottomTh2: '코인/메인넷',
        relatedBottomTh3: '발행번호',
        relatedBottomTh3_1: '추가발급',
        relatedBottomTh3_2: '파괴하다',
        relatedBottomTh4: '거래 해시',
    },
    userToolBlockChainBrowser: {
        title: '블록체인 익스플로러'
    },
    bindingApi: {
        bindBtn: '바인드 API',
        tip: '거래소 API 생성 시 IP 바인딩 필요',
        listTitle: '바인딩 목록',
        list1: '바인딩 해제',
        list2: '사용 가능한 잔액:',
        enterBourse: '교환 선택:',
        enterNotes: '참고:',
        enterBourseErr: '교환을 선택하세요',
        enterApiKeyErr: 'Api 키를 입력하세요',
        enterSecretKeyErr: '비밀 키를 입력하세요',
        enterPassphraseErr: 'PassPhrase를 입력하십시오(OKX 필수)',
        enterNotesErr: '메모를 입력하세요',
        bindSubmit: '제출',
        bindSuccess: '바인딩 성공',
        unBindSuccess: '바인딩 해제 성공'
    },
    hitNewRobot: {
        top1: '스마트 시대, 기술의 미래를 선도하다',
        top2: '새 로봇은 9월 30일 공식 출시됩니다',
        topBtn: '게임 규칙>>',
        hitNewTitle: 'Exchange 히트 새 목록',
        hitSelTitle: '청크를 선택하십시오',
        hitNewlistTh1: '토큰 정보',
        hitNewlistTh2: '토큰 가격',
        hitNewlistTh3: '초기 유동성',
        hitNewlistTh4: '총 유동 자금',
        hitNewlistTh5: '풀 금액',
        hitNewlistTh6: '풀',
        hitNewlistTh7: '남은',
        hitNewlistTh8: '상장 이후',
        createBtn: '만들기',
        createTitle: '로봇 생성',
        createLabel1: '교환 이름:',
        createLabel2: '통화쌍 이름:',
        createLabel3: '목록 시간:',
        createLabel7: '사용 가능한 잔액：',
        createLabel4: '예상 구매 수량:',
        createLabel5: '예상 구매 가격:',
        createLabel6: '사재기 시간：',
        createLabel4Err: '예상 구매 수량을 입력하세요',
        createLabel5Err: '예상 구매 가격을 입력하세요',
        createLabel6Err: '사재기 시간을 선택하세요',
        createTip: '구매 가치는 > = 10USDT',
        createSuccess: '생성 성공! ',
        robotsTitle: '로봇 목록',
        robotListStatus1: '실행 예정',
        robotListStatus2: '종료됨',
        robotListBinanceStatus1: '주문 접수 성공',
        robotListBinanceStatus2: '등록 실패',
        robotsList1: '실행 시간:',
        robotsList2: '로봇 취소',
        robotsList3: '코인 쌍',
        robotsList4: '가격',
        robotsList5: '수량',
        robotsCancel: '취소 성공',
    },
    hitNewRobotRule: {
        title: '반환',
        h2_1: '핵심 장점:',
        label1_1: '효율적인 알고리즘:',
        label1_2: '심층 통합:',
        label1_3: '빅 데이터 처리:',
        label1_4: '스마트 전략:',
        label1_5: '안전:',
        label1_6: '자동 거래:',
        label1_7: '경험 최적화:',
        p1_1: '내장된 효율적인 알고리즘, 밀리초 수준의 거래 결정 및 시장 역학의 정확한 포착. ',
        p1_2: 'Binance, HTX, OKX 등 주류 거래소의 API를 통합하여 포괄적이고 정확한 데이터를 보장합니다. ',
        p1_3: 'Apache Kafka 및 Flink 기술을 사용하여 실시간으로 시장 데이터를 수집하고 처리합니다. ',
        p1_4: 'TensorFlow 또는 PyTorch 프레임워크와 결합하여 과거 데이터와 추세를 사용하여 새로운 전략을 최적화합니다. ',
        p1_5: '분산 아키텍처와 다중 암호화 기술은 사용자 데이터와 거래의 보안을 보장합니다. ',
        p1_6: '향후에는 DEX 자동화 거래와 효율적인 자산 관리를 실현하기 위해 스마트 계약과 크로스체인 기술을 탐구할 것입니다. ',
        p1_7: '인터페이스와 상호 작용 디자인을 지속적으로 최적화하고 직관적인 데이터 시각화 도구를 제공하며 사용자 경험을 개선합니다. ',
        h2_2: '회원 업그레이드 기준:',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: '직접 3명을 추천하면 팀이 100명이 됩니다. ',
        p2_2: '직접 5명을 추천하면 팀이 200명이 됩니다. ',
        p2_3: '5명을 직접 푸시했는데 그 중 2명이 v2에 도달했습니다. ',
        p2_4: '5명 직접 승격, 그 중 2명이 v3에 도달했습니다. ',
        p2_5: '5명을 직접 푸시했는데 그 중 2명이 v4에 도달했습니다. ',
        p2_6: '5명 직접 승격, 그 중 2명이 v5에 도달했습니다. ',
        p2_7: '5명 직접 승격, 그 중 2명이 v6에 도달했습니다. ',
        h2_3: '로봇 배포 기준:',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: '로봇 1개를 얻습니다. ',
        p3_2: '로봇 3개를 얻으세요. ',
        p3_3: '로봇 5개를 얻으세요. ',
        p3_4: '로봇 6개를 얻으세요. ',
        p3_5: '로봇 7개를 얻으세요. ',
        p3_6: '로봇 9개를 얻으세요. ',
        p3_7: '로봇 10개와 선물로 5개를 더 받아 총 15개의 로봇을 얻으세요. ',
        h2_4: '로봇의 효과적인 작동 조건:',
        label4_1: '연속 체크인:',
        label4_2: '활성화 조건:',
        label4_3: '로그인이 중단되었습니다:',
        p4_1: '로봇의 효과적인 작동을 위해서는 회원들이 매일 지속적으로 체크인을 해야 합니다. ',
        p4_2: '계속 로그인한 회원만 새로운 서비스를 활성화할 수 있습니다. ',
        p4_3: '당일 로그인을 놓친 경우 다음 날 새로운 로봇의 실행이 중지되고 로그인이 재개된 다음 날 0시에 자동으로 활성화됩니다. ',
        h2_5: '요약:',
        p5: '본 플랫폼의 디지털 화폐 신창작 로봇 모듈은 효율적인 알고리즘과 지능적인 전략을 통해 회원에게 자동화되고 효율적이며 안전한 신창작 서비스를 제공합니다. 지속적인 기술 발전을 통해 우리는 계속해서 사용자 경험을 최적화하고, 더욱 다양하고 새로운 옵션을 확장하며, 회원들이 자산 가치를 실현할 수 있도록 도울 것입니다.'
    },
    invite: {
        title: '친구 초대',
        info1: '등록/팀에 가입하도록 친구 초대',
        info2: '로봇 오픈 기회/프로모션 혜택을 받을 수 있는 기회를 얻으세요',
        info3: '안녕하세요! TokenTrend 플랫폼에 오신 것을 환영합니다',
        info4: '통화계의 초보자를 위해 특별히 맞춤화된 새로운 도구는 한 번의 클릭으로 사용할 수 있습니다.',
        btn: '초대 링크 복사'
    },
    hyperliquid: {
        searchPlaceholder: '지갑 주소를 입력하여 포지션 조회...',
        searchBtn: '조회',
        title: '고래 포지션 모니터링',
        dataCount: '대호 포지션 {0}개',
        long: '롱',
        short: '숏',
        cross: '교차',
        isolated: '격리',
        positionValue: '포지션 가치',
        positionSize: '포지션 크기',
        entryPrice: '진입 가격',
        markPrice: '마크 가격',
        unrealizedPnl: '미실현 손익',
        noData: '데이터 없음',
        enterAddress: '지갑 주소를 입력하세요',
        enterValidAddress: '유효한 지갑 주소를 입력하세요',
        copyAddress: '주소 복사',
        whale: '고래',
        explorer: '탐색기',
        accountTotalValue: '계정 총 가치',
        perpetual: '무기한',
        freeMarginAvailable: '가용 마진',
        withdrawable: '출금 가능',
        totalPositionValue: '총 포지션 가치',
        leverageRatio: '레버리지 비율',
        marginUsed: '사용 마진',
        usedRatio: '사용률',
        perpTotalValue: '무기한 포지션 총액',
        positionsCount: '{0}개 포지션',
        avgMarginUsedRatio: '평균 마진 사용률',
        directionBias: '방향 편향',
        longExposure: '롱 노출',
        shortExposure: '숏 노출',
        positionDistribution: '포지션 분포',
        longValue: '롱 가치',
        shortValue: '숏 가치',
        roe: 'ROE',
        upnl: '미실현 손익',
        perpPositions: '무기한 포지션 ({0})',
        symbol: '심볼',
        entryAvgPrice: '평균 진입가',
        margin: '마진',
        fundingCost: '자금 비용',
        noPositions: '포지션 없음',
        userAddressRequired: '사용자 주소가 필요합니다',
        addressCopied: '주소가 복사되었습니다',
        copyFailed: '복사 실패',
        bullish: '강세',
        bearish: '약세',
        neutral: '중립'
    }
}